export default __webpack_public_path__ + "static/img28h-33743c1eb93678c39b4e48c04ae56e17.jpg";